import React from 'react';
import Container from '@components/layout/container/container';
import { CustomTopicRefinement } from '@components/atoms/education/refinement/educationRefinement';
import StyledEducationTopicFilter from './educationTopicFilter.style';

function EducationTopicFilter() {
  return (
    <StyledEducationTopicFilter>
      <Container large>
        <CustomTopicRefinement
          className="topic-filter"
          headline="Thema"
          attribute="topicFilter"
          items
        />
      </Container>
    </StyledEducationTopicFilter>
  );
}

export default EducationTopicFilter;
